var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"page-game-instructions__task"},[_c('strong',[_vm._v(_vm._s(_vm.taskNumber)+".")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.task)}}),_vm._v(" "),(_vm.taskExtraDescription)?_c('span',[_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.taskExtraDescription)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }